module.exports = __webpack_public_path__ + "img/cancer_stage_plot.3f72dd3e.svg";